import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataBankListShortService } from "./services";

export const useBankListByIds = () => {
  const { mutateAsync: getListBank } = useMutation({
    mutationKey: "masterDataBankListShortService",
    mutationFn: masterDataBankListShortService,
  });

  const getListBankByIds = useCallback(
    async (ids: number[]) => {
      try {
        if (!ids?.length) return {};

        const data = await getListBank({ ids });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getListBank]
  );

  return {
    getListBankByIds,
  };
};
